import { useMemo, useState } from 'react';
import SectionHeading from './SectionHeading';
import { faqCategories, faqs } from '@/mocks/home';

export default function Faq() {
  const [category, setCategory] = useState('all');
  const [openKey, setOpenKey] = useState<string | null>(faqs[0].q);

  const visible = useMemo(
    () => (category === 'all' ? faqs : faqs.filter((f) => f.category === category)),
    [category],
  );

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题速查"
          desc="把用户最常问的问题整理在这里。可以按类别筛选，也可以直接展开查看答案。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {faqCategories.map((c) => {
            const isActive = category === c.key;
            return (
              <button
                key={c.key}
                type="button"
                onClick={() => setCategory(c.key)}
                aria-pressed={isActive}
                className={`rounded-full border px-4 py-1.5 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? 'border-primary-500 bg-primary-500 text-background-50'
                    : 'border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {c.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {visible.map((f) => {
            const isOpen = openKey === f.q;
            return (
              <div
                key={f.q}
                className={`h-fit rounded-lg border bg-background-100 p-4 transition-colors md:p-5 ${
                  isOpen ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenKey(isOpen ? null : f.q)}
                  aria-expanded={isOpen}
                  className="flex w-full items-start justify-between gap-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-medium leading-relaxed text-foreground-900 md:text-base">{f.q}</span>
                  <i
                    className={`ri-arrow-down-s-line mt-0.5 shrink-0 text-lg text-foreground-500 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <p className="anim-fade mt-3 border-t border-background-200 pt-3 text-sm leading-relaxed text-foreground-600">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}